var map = {
	"./applog/applog.module": [
		"./src/app/routes/applog/applog.module.ts",
		"common",
		"applog.module"
	],
	"./blob/blob.module": [
		"./src/app/routes/blob/blob.module.ts",
		"common",
		"blob.module"
	],
	"./category/category.module": [
		"./src/app/routes/category/category.module.ts",
		"common",
		"category.module"
	],
	"./content/content.module": [
		"./src/app/routes/content/content.module.ts",
		"common",
		"content.module"
	],
	"./facility/facility.module": [
		"./src/app/routes/facility/facility.module.ts",
		"common",
		"facility.module"
	],
	"./home/home.module": [
		"./src/app/routes/home/home.module.ts",
		"home.module"
	],
	"./newsfeed/newsfeed.module": [
		"./src/app/routes/newsfeed/newsfeed.module.ts",
		"common",
		"newsfeed.module"
	],
	"./settings/settings.module": [
		"./src/app/routes/settings/settings.module.ts",
		"settings.module"
	],
	"./tutorial/tutorial.module": [
		"./src/app/routes/tutorial/tutorial.module.ts",
		"tutorial.module",
		"common"
	],
	"./upload/upload.module": [
		"./src/app/routes/upload/upload.module.ts",
		"common",
		"upload.module"
	],
	"./user/user.module": [
		"./src/app/routes/user/user.module.ts",
		"common",
		"user.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main